import { createModel } from '@/store/tools';
import { isPlat, isOC } from '@/assets/js/authType';

const model = {
    namespace: 'deliverycomplain',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getfindComplaints': T('getfindComplaints'), // 配送投诉--列表
            'getcheckComplaint': T('getcheckComplaint'), // 配送投诉--详情
            'getComplaintSourceTypeEnum': T('getComplaintSourceTypeEnum'), // 投诉人类型
            'getPunishmentDefault': T('getPunishmentDefault'), // 新建罚单-获取惩罚默认信息
        },
        actions: {
             'getfindComplaints': A('getfindComplaints'), // 配送投诉--列表
             'getcheckComplaint': A('getcheckComplaint'), // 配送投诉--详情
             'getComplaintSourceTypeEnum': A('getComplaintSourceTypeEnum'), // 投诉人类型
             'getPunishmentDefault': A('getPunishmentDefault'), // 新建罚单-获取惩罚默认信息
        },
        sagas: {
            'getfindComplaints': S('getfindComplaints', '/?cmd=com.xqxc.api.pig.mis.order.DeliveryComplaintMisService.findComplaints'),
            'getcheckComplaint': S('getcheckComplaint', '/?cmd=com.xqxc.api.pig.mis.order.DeliveryComplaintMisService.checkComplaint'),
            'getComplaintSourceTypeEnum': S('getComplaintSourceTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getPunishmentDefault': S('getPunishmentDefault', '/?cmd=com.xqxc.api.pig.mis.order.DeliveryComplaintMisService.getPunishmentDefault'),
        },
        reducers: {
            'findComplaints': R('getfindComplaints', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'checkComplaint': R('getcheckComplaint', {}),
            'ComplaintSourceTypeEnum': R('getComplaintSourceTypeEnum', []),
            'PunishmentDefault': R('getPunishmentDefault', {}),
        }
    })
};
export default createModel(model);